import { render, staticRenderFns } from "./ModalShareNote.vue?vue&type=template&id=6ca97e72"
import script from "./ModalShareNote.vue?vue&type=script&lang=js"
export * from "./ModalShareNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports